import { UserPinModalNew } from './UserPinModalNew';

export default UserPinModalNew;
